import { UIComponentImpl, UIComponentState, UIDataModel, UIComponentHandler } from '../../../../toolkit/uicomponent';

import { BaseContext } from '../../../../../utils/basecontext';

import { UIComponentView } from '../../../../toolkit/uicomponentview';

import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ForgotPasswordOTPMessageViewImpl } from './forgotpasswordotpmessageview';
import { ForgotPasswordOTPMessageCSSStyleImpl } from './forgotpasswordotpmessagecss';
import { ChildComponentProps } from '../../../mainwrappercomponent';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { ForgotPasswordOTPMessageAPIModelImpl, ForgotPasswordOTPMessageAPIModel } from './forgotpasswordotpmessageapimodel';
import { ForgotPasswordDtoImpl } from '../../../../../core/dto/forgotpassword/forgotpassworddto';
import { APIFeatures } from '../../../../../core/util/apifeatures';
import { RoutingFeatures } from '../../../navigation/routingfeature';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';


  



export interface ForgotPasswordOTPMessageComponentProps extends ChildComponentProps
{
    msisdn: string;
    sectoken: string;
}

export interface ForgotPasswordOTPMessageComponentState extends UIComponentState
{
    isOTPMessageShow: boolean;
    isResetPasswordSuccess: boolean;
    isResendButtonRestricted:boolean;
    sectoken: string;
    countDownTime:number;
}

export interface ForgotPasswordOTPMessageComponentHandler extends UIComponentHandler
{
    onCloseButtonClicked():void;
    onLoginButtonClicked(): void;
    onResetPasswordButtonClicked():void;
    onResendOtpButtonClicked():void;
    onLogoClicked(): void;
    onResetPassword():void;
}

export class ForgotPasswordOTPMessageComponent extends UIComponentImpl<ForgotPasswordOTPMessageComponentProps, ForgotPasswordOTPMessageComponentState, UIDataModel>
implements ForgotPasswordOTPMessageComponentHandler
{
    private timer: any;
    private countDownTimerInterval:any;
    private duration = Number(this.getContext().getProperty().getResendOtpTimeout());
    private countDownSeconds = this.duration/1000;

    constructor(props: ForgotPasswordOTPMessageComponentProps)
    {
        super(props);

        this.state = {isOTPMessageShow : true, sectoken: props.sectoken,
             isResetPasswordSuccess: false,isResendButtonRestricted:false,countDownTime:this.countDownSeconds};
    }
    startCountDown() 
    {
        console.log(this.countDownSeconds);
     let countDownTimer = document.getElementById("countdown");

     let formatTime = (time:any) =>
     `${String(Math.floor(time / 60)).padStart(2, "0")}:${String(
       time % 60
     ).padStart(2, "0")}`;
      
        this.countDownTimerInterval= setInterval(async() => {
          
     
          if (this.countDownSeconds < 0 ) {
            clearInterval(this.countDownTimerInterval);
            countDownTimer!==null && (countDownTimer.innerHTML = " ");
          
        
          }
          else{
           
         countDownTimer!==null && (countDownTimer.innerHTML = String(formatTime(this.countDownSeconds--)));
          }
         
        }, 900);
      }
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ForgotPasswordOTPMessageViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ForgotPasswordOTPMessageCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ForgotPasswordOTPMessageAPIModelImpl(applicationContext, apiModelHandler);
    }
    onLogoClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.HOME, false);
    }
    onResetPassword():void{
        this.setState({isOTPMessageShow: false});

        (this.getView() as ForgotPasswordOTPMessageViewImpl).showLoader();
        let resetPassword = (this.getView() as ForgotPasswordOTPMessageViewImpl).getData() as ForgotPasswordDtoImpl;
        resetPassword.setSecToc(this.state.sectoken);
        resetPassword.setMsisdn(this.props.msisdn);
        this.getAPIModel().resetPassword(resetPassword);
        
        

    }
    onResetPasswordButtonClicked(): void 
    {
        (this.getView() as ForgotPasswordOTPMessageViewImpl).validateData();
       
    }

    onLoginButtonClicked(): void 
    {
        this.props.routeNextFeature(RoutingFeatures.LOGIN, false);
    }

    componentDidMount()
    {
      
    }
    onResendOtpButtonClicked(): void 
    {
        if(this.state.isResendButtonRestricted === true)
        {
           
        }
        else
        {
            (this.getView() as ForgotPasswordOTPMessageViewImpl).showLoader();
            this.setState({isOTPMessageShow: false});
            this.getAPIModel().resendOtp(this.props.msisdn);
            this.setState({countDownTime:this.countDownSeconds});
      
        }
    }

    onCloseButtonClicked():void
    {   
        this.setState({isOTPMessageShow: !this.state.isOTPMessageShow});
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        
        (this.getView() as ForgotPasswordOTPMessageViewImpl).dismissLoader();
        if(feature === APIFeatures.RESET_PASSWORD)
        {
            this.setState({isResetPasswordSuccess: true});
        }
        else if(feature === APIFeatures.SEND_OTP)
        {   
            this.setState({isOTPMessageShow: true, sectoken: (data as SendOTPDto).getSecToc()});
            this.setState({isOTPMessageShow: true, sectoken: (data as SendOTPDto).getSecToc(),isResendButtonRestricted:true});
                this.countDownSeconds = this.duration/1000;
                this.startCountDown();
           this.timer = setTimeout(this.setState.bind(this, {isResendButtonRestricted:false}), Number(this.duration));
         
        }
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        
        clearTimeout(this.timer);
        clearInterval(this.countDownTimerInterval);
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
       
        (this.getView() as ForgotPasswordOTPMessageViewImpl).dismissLoader();
        (this.getView() as ForgotPasswordOTPMessageViewImpl).showPopup("",description,AlertType.ERROR);
    }
    
    getAPIModel(): ForgotPasswordOTPMessageAPIModel {
        return super.getAPIModel() as ForgotPasswordOTPMessageAPIModel;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/forgotpasswordotp/forgotpasswordotpmessage/forgotpasswordotpmessagecomponent.tsx